import React from "react";
import { Flex } from "@jsq/ds/core";
import { TabSection } from "../TabSection";
import { getControlTowerTabs } from "../TabSection/tabConfig";
import { IndividualsTable } from "./IndividualsTable";
import * as styles from "./styles_vanilla.css";

type IndividualsViewProps = {
  showManagerTabs?: boolean;
  hasWorkflowAccess?: boolean;
};

export const IndividualsView: React.FC<IndividualsViewProps> = ({
  showManagerTabs = false,
  hasWorkflowAccess = false,
}) => {
  const tabs = getControlTowerTabs(showManagerTabs, hasWorkflowAccess);

  return (
    <Flex flexDirection="column" className={styles.container} data-testid="individuals-view">
      <TabSection tabs={tabs} showManagerTabs={showManagerTabs} />
      <Flex flexDirection="column" className={styles.contentContainer}>
        <IndividualsTable />
      </Flex>
    </Flex>
  );
};
